export * from "-!../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=1af4460e&"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=template&id=1af4460e&
// module id = 123
// module chunks = 32